module.exports = __webpack_public_path__ + "img/analisi-impianto.569e46e9.jpg";